import {Component, HostBinding, Input} from '@angular/core';
import {SvgIconComponent} from "angular-svg-icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-x-icon-button',
  standalone: true,
  imports: [SvgIconComponent, NgIf],
  templateUrl: './x-icon-button.component.html',
  styleUrl: './x-icon-button.component.less',
})
export class XIconButtonComponent {
  @HostBinding('class.disabled') @Input() disabled: boolean = false;
  @HostBinding('class') @Input() type: 'icon-button' = 'icon-button';
  @HostBinding('class.state-active') @Input() active: boolean | null = false;
  @Input() name: string = '';
  @Input() color = 'currentColor';
  @Input() loading = false;
}
